export default __webpack_public_path__ + "static/media/Group9258.a075e2d7.svg";